<template>
  <div class="list__item-loading-wrapper">
    <div v-for="item in itemsToRender" :key="item" class="list__item-loading-group">
      <div class="list__item-loading"></div>
      <div class="list__item-loading"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  itemsToRender: {
    type: Number,
    required: true
  }
})
</script>

<style lang="scss">
@use '@/design-system/design-tokens/variables.scss';
//This is just a demo, check animation etc.
.list__item-loading {
  background: variables.$color-greyscale-line-grey;
  background: linear-gradient(
    to right,
    variables.$color-greyscale-light 0%,
    variables.$color-disabled 20%,
    variables.$color-disabled 60%,
    variables.$color-greyscale-light 100%
  );
  background-size: 200% 100%;
  animation: 1.2s loading linear infinite;
  //Dont know if we should make width and height to variables? Feels like a special case
  &:first-child {
    width: 154px;
    height: 16px;
  }
  &:last-child {
    width: 74px;
    height: 12px;
  }
  &-group {
    display: flex;
    flex-direction: column;
    padding: variables.$padding-xsmall 0;
    row-gap: variables.$gap-large;
  }
  &-wrapper {
    display: flex;
    flex-direction: column;
    row-gap: variables.$gap-xlarge;
    overflow: hidden;
  }
}
@keyframes loading {
  to {
    background-position-x: -200%;
  }
}
</style>
